import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'

import { UserFormValue } from '@flowx/designer/modules/access-management/access-management.utils'
import { AccessManagementUser } from '@flowx/designer/modules/workspaces/shared/workspace.utils'
import { OrganizationAdminDesignerUsersApiService } from '@flowx/designer/shared/api/organization-admin-designer-users.api'

@Injectable({ providedIn: 'root' })
export class SelfEditUserApiService extends OrganizationAdminDesignerUsersApiService {
  protected override get usersUrl(): string {
    return `${this.authApiUrl}/iam/cas/users/me`
  }

  override getUserForEditing(): Observable<AccessManagementUser> {
    return this.get(`${this.usersUrl}`)
  }

  override updateUser(payload: UserFormValue): Observable<AccessManagementUser> {
    return this.put(`${this.usersUrl}`, payload)
  }

  override updatePassword(userId: string, password: string): Observable<void> {
    return this.patch(`${this.usersUrl}/password`, {
      newPassword: password,
    })
  }
}
